import { ReactComponent as OtherIcon } from '../../../../assets/icons/timeline/greenInjuryIcon.svg';
import { map } from 'lodash';
import useEventList from './useEventList';
import { eventType } from '../NewEventModal';

export default function useOtherEvent(patientUuid: string) {
  const otherList = useEventList(patientUuid, []);

  return map(
    otherList ?? [],
    ({ eventTimestamp, title, therapistComment, uuid, affectedSide }) => ({
      name: title,
      date: eventTimestamp,
      icon: OtherIcon,
      description: therapistComment ?? '',
      id: uuid,
      tabName: eventType.other,
      affectedSide
    })
  );
}
